import { render, staticRenderFns } from "./OverflowRightSection.vue?vue&type=template&id=5abe8897&scoped=true"
import script from "./OverflowRightSection.vue?vue&type=script&lang=js"
export * from "./OverflowRightSection.vue?vue&type=script&lang=js"
import style0 from "./OverflowRightSection.vue?vue&type=style&index=0&id=5abe8897&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe8897",
  null
  
)

export default component.exports